/**
 * RequireRightsManager — рубеж маршрута экрана прав (Блок 2 · Ф8 · В-Э).
 *
 * Стоит ВНУТРИ группы `RequireAccessLevel({ allowed: ['SUPERVISOR'] })` и
 * сужает её: уровень супервайзера несут две должности, а маршруты прав сервер
 * открывает только штатной (`canManageRights`; умолчание 4 Р-211). Без этого
 * рубежа носитель спящей должности `CEO` открыл бы страницу по прямому адресу
 * и увидел бы «не удалось загрузить» вместо «доступ запрещён».
 *
 * Загрузку профиля и его отсутствие обрабатывает внешний `RequireAccessLevel`:
 * сюда отрисовка доходит уже с профилем, несущим уровень. Профиль без
 * должности предикат закрывает — как и всё «не знаю».
 *
 * ⚠️ ОШИБКУ ЗАПРОСА ПРОФИЛЯ ЭТОТ РУБЕЖ НЕ ЧИТАЕТ, И НЕ ДОЛЖЕН (Ф8 · В-О2,
 * фикс-пак 2). Он решает по ДАННЫМ профиля; при отказе фонового перезапроса
 * данные остаются прежними, и экран не меняется. Понадобится здесь увод на
 * вход — только через `isSessionLost` (`hooks/use-me.ts`), а не условием
 * `isError || …`: именно такое условие во втором страже выбрасывало людей на
 * вход при сбое сети. Путь держит `routes-session-failure.test.tsx`.
 */
import * as React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useMe } from '@/hooks/use-me';
import { canManageRights } from '@/lib/rights-manager';

export function RequireRightsManager({
  children,
}: {
  children?: React.ReactNode;
}): React.ReactElement {
  const location = useLocation();
  const { data: me } = useMe();
  if (!canManageRights(me)) {
    return <Navigate to="/forbidden" replace state={{ from: location.pathname }} />;
  }
  return <>{children ?? <Outlet />}</>;
}
